import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { Map } from "immutable";
import { FormSection } from "redux-form";
import { form, Form as AppForm } from "MODULES/shared/components/Forms";
import { ShippingSection } from "MODULES/shared/components/ShippingSection";
import { validate } from "MODULES/SalesOrders/components/shared/FormSections/ShippingSection";
import * as actions from "MODULES/MistakeShipments/actions";
import withMistakeShipment from "../../decorators/withMistakeShipment";
import {
  COMPANY,
  DROPSHIP
} from "../../../shared/components/ShippingSection/shippingTypes";

export function Form({ mistakeShipment, ...props }) {
  const shipToOptions = [
    {
      text: "Company",
      value: COMPANY
    },
    {
      text: "Other",
      value: DROPSHIP
    }
  ];

  return (
    <AppForm {...props}>
      <AppForm.Body>
        <FormSection name="">
          <h4>Ship To</h4>
          <ShippingSection
            shippingType="ship_to"
            shipToOptions={shipToOptions}
            shipToCompany={mistakeShipment.get("ship_to_company")}
          />
        </FormSection>
      </AppForm.Body>
    </AppForm>
  );
}

Form.propTypes = {
  salesOrder: T.instanceOf(Map)
};

export default connect(undefined, {
  onSubmit: actions.update
})(
  withMistakeShipment(
    form({
      form: "mistakeShipmentShipToDetails",
      validate
    })(Form)
  )
);



// WEBPACK FOOTER //
// ./app/modules/MistakeShipments/components/Detail/ShipToForm.jsx